import getFieldValuesByName from './get_field_values_by_name';

export default function castSpell(form, spellName) {
  return {
    name: spellName,
    result: getFieldValuesByName(form, spellName)
  };
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/form/cast_spell.js